module.exports = __webpack_public_path__ + "img/motsu_pot.eb93cc85.jpg";